/**
 * The known emission lines the instrument names, plots and voices. The
 * manifest's `features` block carries their rest wavelengths per object.
 */

export type LineKey = "Halpha" | "Hbeta" | "Hgamma" | "OIII";

export const LINE_KEYS: readonly LineKey[] = ["Halpha", "Hbeta", "Hgamma", "OIII"];

/** Display glyphs for known line keys. */
export const LINE_GLYPHS: Record<LineKey, string> = {
  Hgamma: "Hγ",
  Hbeta: "Hβ",
  OIII: "[O III]",
  Halpha: "Hα",
};

/** What the user has soloed: everything, the continuum, the sweep plucks, or one line. */
export type LineSolo = "all" | "continuum" | "sweep" | LineKey;

/**
 * Whether a voice sounds under the current solo. `key` is a known line, the
 * continuum, or null for an unidentified (discovery) peak. Discovery peaks
 * ride along with any line solo and are silenced only by the sweep solo.
 */
export function isAudible(key: string | null, solo: LineSolo): boolean {
  if (solo === "all") return true;
  if (key === null) return solo !== "sweep";
  return key === solo;
}
